import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RegisterUserService } from '../../services/register-user.service';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '../../services/auth.service';

export const registerGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  
  const router = inject(Router);

  const registerService = inject(RegisterUserService);

  const authService = inject(AuthService)

  authService.clearAuthData();
  
  const token = route.paramMap.get('token');

  if(!token) {
    router.navigate(['/invitation-invalid']);
    return of(false);
  } else {
    
    return registerService.validateToken(token).pipe(
      map((response: any) => {
        return response.status === "success";
      }),
      // catchError(() => of(router.createUrlTree(['/invitation-invalid'])))
      catchError(() => {
        router.navigate(['/invitation-invalid']);
        return of(false);
      })
    );

  }
}
